export const layoutTypes = {
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
  SET_OPEN_DRAWER: 'SET_OPEN_DRAWER',
  TOGGLE_LOADING_MAIN: 'LOADING_MAIN',
  HIDE_BREADCRUMS: "HIDE_BREADCRUMS",
  SHOW_BREADCRUMS: "SHOW_BREADCRUMS",
  TITLE: "TITLE",
  SUB_BREADCRUMBS: "SUB_BREADCRUMBS",
  SET_PARAMS: "SET_PARAMS",
  SHOW_DSA_MENU: 'SHOW_DSA_MENU',
  HIDE_DSA_MENU: 'HIDE_DSA_MENU',
  CHANGE_APP_TITLE: 'CHANGE_APP_TITLE',
  SET_HIDDEN_MENU: 'SET_HIDDEN_MENU',
  SHOW_EVA_MENU: 'SHOW_EVA_MENU',
  HIDE_EVA_MENU: 'HIDE_EVA_MENU',

};